export const TRANSLATIONS_AN = {
    welcome: "Welcome to the tutorial",
};